import { useNuxtApp, useRuntimeConfig } from "#imports";
export function useSegment(segment) {
  const $segment = segment ?? useNuxtApp().$segment;
  const config = useRuntimeConfig().public.segment;
  const logPrefix = shouldTrack() ? "segment" : "segment-mock";
  function shouldTrack() {
    return process.client && config.settings?.writeKey && (process.env.NODE_ENV !== "development" || config.trackDevMode);
  }
  function identify(...args) {
    wrapFn("identify")(...args);
  }
  function alias(...args) {
    wrapFn("alias")(...args);
  }
  function page(...args) {
    wrapFn("page")(...args);
  }
  function screen(...args) {
    wrapFn("screen")(...args);
  }
  function group(...args) {
    wrapFn("group")(...args);
  }
  function track(...args) {
    wrapFn("track")(...args);
  }
  function trackSubmit(...args) {
    wrapFn("trackSubmit")(...args);
  }
  function trackClick(...args) {
    wrapFn("trackClick")(...args);
  }
  function trackLink(...args) {
    wrapFn("trackLink")(...args);
  }
  function reset(...args) {
    return wrapFn("reset")(...args);
  }
  function raw(name, ...args) {
    return wrapFn("raw")(...args);
  }
  function wrapFn(fnName) {
    return function analyticsFn(...args) {
      if (shouldTrack()) {
        return $segment[fnName](...args);
      }
      if (config.debugEnabled) {
        console.log(`[${logPrefix}@${fnName}]`, ...args);
      }
    };
  }
  return {
    $segment,
    identify,
    alias,
    page,
    screen,
    group,
    track,
    trackSubmit,
    trackClick,
    trackLink,
    reset,
    raw
  };
}
